






























































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import printJS from 'print-js';
import { Channel, ChannelType, PusherEvent } from '@getaccept/pusher';
import { IManuallySignedPage } from '@signing-page/documents/types/manually-signed-page';
import { chatUpdatedSubscription } from '@signing-page/api/chat/graphql/chat.subscriptions';
import { ERecipientStatus } from '@signing-page/recipient/types/enums/recipient-status';
import { IIntegration } from '@signing-page/integrations/types/integration';
import {
  actionSetCurrentDocumentPages,
  actionTrackFieldClick,
  actionTrackContentLinkClick,
  actionStartPageViewStopWatch,
  actionResetPageViewStopWatch,
  actionPausePageViewStopWatch,
  actionResumePageViewStopWatch,
  actionTrackVideo,
  actionSuspendPageTracking,
  actionResumePageTracking,
  actionEnableTracking,
  actionDisableTracking,
  actionTrackVisitTime,
} from '@signing-page/tracking/store/tracking.actions';
import {
  idleInteractionInterval,
  pageTrackingHeartbeatInterval,
} from '@signing-page/tracking/constants/tracking';
import { reviewTimerDuration } from '@signing-page/documents/constants/review-timer-duration';
import { namespace as entityNamespace } from '@signing-page/entity/store/entity.store';
import { getterPageViewStopWatchPaused } from '@signing-page/tracking/store/tracking.getters';
import { namespace as trackingNamespace } from '@signing-page/tracking/store/tracking.store';
import { namespace as chatNamespace } from '@signing-page/chat/store/chat.store';
import { namespace as integrationsNamespace } from '@signing-page/integrations/store/integrations.store';
import { namespace as alertNamespace } from '@signing-page/alert/store/alert.store';
import { actionShowInfoAlert } from '@signing-page/alert/store/alert.actions';
import {
  actionLoadChat,
  actionAddComment,
  actionSetIsOpen,
  actionAutoComment,
  actionReadComments,
  actionSetSystemMessageOpen,
} from '@signing-page/chat/store/chat.actions';
import {
  actionUpdatePageWidth,
  actionLoadFields,
  actionUpdateFieldValue,
  actionAddVerifiedInitialFieldId,
} from '@signing-page/fields/store/field.actions';

import { getterPositionedFields } from '@signing-page/fields/store/field.getters';
import { namespace as fieldNamespace } from '@signing-page/fields/store/field.store';
import {
  actionLoadDocument,
  actionSetFocusedRequiredId,
  actionSetAttachmentView,
  actionSendDocumentStatus,
  actionLoadAfterSign,
  actionRejectDocument,
  actionUploadAttachment,
  actionForwardToRecipient,
  actionSetForwardStatus,
  actionSetRecipientStatus,
  actionSendEventLog,
  actionSendPusherStatus,
  actionLoadDocumentRevisions,
  actionSetRevisionViewedByRecipient,
  actionDownloadDocument,
  actionDownloadDocumentComplete,
  actionGetPdfUrl,
} from '@signing-page/documents/store/document.actions';
import {
  getterAreAttachmentsUploading,
  getterCurrentRecipient,
  getterRecipientsTurnToSign,
  getterMyTurnToSign,
  getterVideoReminder,
  getterViewableRecipients,
} from '@signing-page/documents/store/document.getters';
import {
  actionLoadStripe,
  actionLoadAuthorizeNet,
} from '@signing-page/integrations/store/integrations.actions';
import { IUploadAttachment } from '@signing-page/attachments/types/upload-attachment';
import { namespace as documentNamespace } from '@signing-page/documents/store/document.store';
import { namespace as sessionNamespace } from '@signing-page/session/store/session.store';
import { throttle } from '@/common/helpers';
import { documentSignaturePagesSubscription } from '@signing-page/api/documents/graphql/document.subscriptions';
import SigningOptions from '@signing-page/signing/components/SigningOptions.vue';
import TopBar from '@signing-page/signing/components/TopBar.vue';
import { BrandingHelper } from '@signing-page/helpers/branding.helper';
import { TrackingHelper } from '@signing-page/tracking/helpers/tracking.helper';

import { IBankId } from '@signing-page/signing/types/bankid';
import { PageHelper } from '@signing-page/helpers/page.helper';
import { EDocumentStatus } from '@signing-page/documents/types/enums/document-status';
import {
  ESigningAction,
  namespace as signingNameSpace,
} from '@signing-page/signing/store/signing.constants';
import DocumentContainer from '@signing-page/signing/components/DocumentContainer.vue';
import { IDocument } from '@signing-page/documents/types/document';
import { IComment } from '@signing-page/chat/types/comment';
import Chat from '@signing-page/chat/components/Chat.vue';
import DocumentHeader from '@signing-page/documents/components/DocumentHeader.vue';
import BottomBar from '@signing-page/signing/components/BottomBar.vue';
import SignActions from '@signing-page/signing/components/SignActions.vue';
import MainMenu from '@signing-page/documents/components/MainMenu.vue';
import EngageVideo from '@signing-page/video/components/EngageVideo.vue';
import VideoReminder from '@signing-page/video/components/VideoReminder.vue';
import DocumentAction from '@signing-page/signing/components/DocumentAction.vue';
import * as supportedBrowsersRegExp from '@signing-page/supported-browsers-reg-exp.js';
import UnsupportedBrowserModal from '@signing-page/signing/components/UnsupportedBrowserModal.vue';
import RecipientsModal from '@signing-page/recipients/components/RecipientsModal.vue';
import { IEntity } from '@signing-page/entity/types/entity';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { SigningHelper } from '@signing-page/signing/helpers/signing.helper';
import { ESidebarOptionType } from '@signing-page/documents/types/enums/sidebar-option-type';
import { IDocumentAttachment } from '@/types/document-attachment';
import { ERecipientRole } from '@/dealroom/recipients/types/enums/recipient-role';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import { IDocumentPage } from '@/types/document-page';
import { IField } from '@/dealroom/fields/types/field';
import DocumentContentPage from '@/dealroom/components/DocumentContentPage.vue';
import Icon from '@/components/Icon.vue';
import { ITheme } from '@signing-page/entity/types/theme';
import LoaderCircluar from '@/components/LoaderCircular.vue';
import { EnumAttachmentTypes } from '@/types/Attachment';
import { IDocumentOption } from '@signing-page/documents/types/document-option';
import { documentOptions } from '@signing-page/documents/constants/document-options';
import LobbyCard from '@signing-page/lobby/components/LobbyCard.vue';
import RejectModal from '@signing-page/signing/components/modals/RejectModal.vue';
import SignModal from '@signing-page/signing/components/modals/SignModal.vue';
import ForwardModal from '@signing-page/signing/components/modals/ForwardModal.vue';
import ApproveModal from '@signing-page/signing/components/modals/ApproveModal.vue';
import Stripe from '@signing-page/integrations/stripe/components/Stripe.vue';
import AuthorizeNet from '@signing-page/integrations/authorizenet/components/AuthorizeNet.vue';
import { isWindowSize } from '@/helpers/window-size.helper';
import { EWindowSize } from '@/enums/window-size';
import { IForwardRecipientInfo } from '@signing-page/signing/types/forward-recipient-info';
import ThemedButton from '@signing-page/documents/components/ThemedButton.vue';
import PhoneModal from '@signing-page/integrations/twilio/components/PhoneModal.vue';
import { EDocumentEvent } from '@signing-page/documents/types/enums/document-event';
import { IVideo } from '@signing-page/documents/types/video';
import { FieldHelper } from '@/dealroom/fields/helpers/field.helper';
import UploadModal from '@/components/UploadModal.vue';
import { actionSetRecipientFirstOpen } from '@signing-page/session/store/session.actions';
import InitialsModal from '@signing-page/signing/components/modals/InitialsModal.vue';
import ReviewChangesModal from '@signing-page/lobby/components/ReviewChangesModal.vue';
import { IDocumentRevision } from '@signing-page/documents/types/document-revision';
import { EDocumentRevisionStatus } from '@/types/document-revision';
import { isPopupBlocked } from '@signing-page/common/utils/window';

@Component({
  components: {
    Chat,
    TopBar,
    DocumentAction,
    DocumentContentPage,
    DocumentHeader,
    BottomBar,
    ThemedButton,
    SignActions,
    UnsupportedBrowserModal,
    DocumentContainer,
    RecipientsModal,
    MainMenu,
    EngageVideo,
    Icon,
    LoaderCircluar,
    UploadModal,
    SigningOptions,
    LobbyCard,
    RejectModal,
    SignModal,
    ApproveModal,
    ForwardModal,
    Stripe,
    AuthorizeNet,
    PhoneModal,
    VideoReminder,
    InitialsModal,
    ReviewChangesModal,
  },
  data: () => ({
    EDocumentStatus,
    BrandingHelper,
    ERecipientStatus,
  }),
})
export default class Signing extends Vue {
  @State('entity', { namespace: entityNamespace }) entity: IEntity;
  @State('documentId') documentId: string;
  @State('recipientId') recipientId: string;
  @State('authId') authId: string;
  @State('isPreview') isPreview: boolean;
  @State('pusherConnected') pusherConnected: boolean;
  @Watch('pusherConnected') subscribePusher(pusherConnected: boolean) {
    if (pusherConnected) {
      this.addPusherSubscriptions();
    }
  }
  @State('isLoading', { namespace: documentNamespace }) isLoading: boolean;
  @State('revisionsIsLoading', { namespace: documentNamespace }) revisionsIsLoading: boolean;
  @State('revisionsViewedLoading', { namespace: documentNamespace })
  revisionsViewedLoading: boolean;
  @State('isButtonLoading', { namespace: documentNamespace }) isButtonLoading: boolean;
  @State('forwarded', { namespace: documentNamespace }) forwarded: boolean;
  @State('document', { namespace: documentNamespace }) document: IDocument;
  @Watch('document') async updateDocumentRevisions() {
    if (
      !this.latestSealedRevision.viewedByRecipient &&
      this.document?.documentRevisions?.length !== 1
    ) {
      this.showReviewChangesModal = true;
      await this.setRevisionViewed(this.latestSealedRevision.revision);
      await this.loadDocumentRevisions();
    }
  }
  @State('pdfUrl', { namespace: documentNamespace }) pdfUrl: string;
  @State('comments', { namespace: chatNamespace }) comments: IComment[];
  @State('pageWidth', { namespace: `${documentNamespace}/${fieldNamespace}` }) pageWidth: number;
  @State('currentDocumentPages', { namespace: trackingNamespace })
  currentDocumentPages: IDocumentPage[];
  @State('pageViewStopWatch', { namespace: trackingNamespace }) pageViewStopWatch: any;
  @State('isOpen', { namespace: chatNamespace }) isChatOpen: boolean;
  @State('focusedRequiredId', { namespace: documentNamespace }) focusedRequiredId: string;
  @State('bankId', { namespace: signingNameSpace }) bankId: IBankId;
  @State('theme', { namespace: entityNamespace }) theme: ITheme;
  @State('uploadingAttachmentIds', { namespace: documentNamespace })
  uploadingAttachmentIds: string[];
  @State('stripe', { namespace: integrationsNamespace }) stripeIntegration: IIntegration;
  @State('authorizeNet', { namespace: integrationsNamespace })
  authorizeNetIntegration: IIntegration;
  @State('commentsRead', { namespace: chatNamespace }) commentsRead: number;
  @State('systemMessageOpen', { namespace: chatNamespace }) chatSystemMessageOpen: boolean;
  @State('recipientFirstOpen', { namespace: sessionNamespace }) recipientFirstOpen: boolean;
  @State('initials', { namespace: `${signingNameSpace}` })
  initials: string;
  @State('selectedInitialFieldId', { namespace: `${signingNameSpace}` })
  selectedInitialFieldId: string;
  @State('verifiedInitialFieldIds', { namespace: `${documentNamespace}/${fieldNamespace}` })
  verifiedInitialFieldIds: string[];
  @State('token', { namespace: sessionNamespace }) token: { jwt: string; exp: number };
  @State('isDownloading', { namespace: documentNamespace }) isDownloading: boolean;

  @Action(ESigningAction.RestartPoll, { namespace: signingNameSpace }) actionRestartPoll: any;
  @Action(ESigningAction.CancelBankIdTransaction, { namespace: signingNameSpace })
  actionCancelBankIdTransaction: any;
  @Action(ESigningAction.ApproveDocument, { namespace: signingNameSpace })
  actionApproveDocument: any;
  @Action(ESigningAction.AddInitials, { namespace: signingNameSpace })
  addInitials: any;
  @Action(ESigningAction.SetSelectedInitialFieldId, { namespace: signingNameSpace })
  setSelectedInitialFieldId: any;
  @Action(actionForwardToRecipient, { namespace: documentNamespace }) actionForwardToRecipient: any;
  @Action(actionSetForwardStatus, { namespace: documentNamespace }) actionSetForwardStatus: any;

  @Action('loadEntity', { namespace: entityNamespace }) loadEntity: any;
  @Action(actionLoadDocument, { namespace: documentNamespace }) loadDocument: any;
  @Action(actionLoadDocumentRevisions, { namespace: documentNamespace }) loadDocumentRevisions;
  @Action(actionSetRevisionViewedByRecipient, { namespace: documentNamespace }) setRevisionViewed;
  @Action(actionLoadChat, { namespace: chatNamespace }) loadChat: any;
  @Action(actionAddComment, { namespace: chatNamespace }) addComment: any;
  @Action(actionAutoComment, { namespace: chatNamespace }) autoComment: any;
  @Action('setIds') setIds: any;
  @Action(actionLoadFields, { namespace: `${documentNamespace}/${fieldNamespace}` })
  loadFields: any;
  @Action(actionUpdatePageWidth, { namespace: `${documentNamespace}/${fieldNamespace}` })
  updatePageWidth: any;
  @Action(actionUpdateFieldValue, { namespace: `${documentNamespace}/${fieldNamespace}` })
  actionUpdateFieldValue: any;
  @Action(actionSetCurrentDocumentPages, { namespace: trackingNamespace })
  actionSetCurrentDocumentPages: any;
  @Action(actionTrackFieldClick, { namespace: trackingNamespace })
  actionTrackFieldClick: any;
  @Action(actionTrackContentLinkClick, { namespace: trackingNamespace })
  actionTrackContentLinkClick: any;
  @Action(actionStartPageViewStopWatch, { namespace: trackingNamespace })
  actionStartPageViewStopWatch;
  @Action(actionResetPageViewStopWatch, { namespace: trackingNamespace })
  actionResetPageViewStopWatch;
  @Action(actionPausePageViewStopWatch, { namespace: trackingNamespace })
  actionPausePageViewStopWatch;
  @Action(actionResumePageViewStopWatch, { namespace: trackingNamespace })
  actionResumePageViewStopWatch;
  @Action(actionEnableTracking, { namespace: trackingNamespace })
  actionEnableTracking;
  @Action(actionDisableTracking, { namespace: trackingNamespace })
  actionDisableTracking;
  @Action(actionTrackVideo, { namespace: trackingNamespace }) actionTrackVideo;
  @Action(actionSuspendPageTracking, { namespace: trackingNamespace }) actionSuspendPageTracking;
  @Action(actionResumePageTracking, { namespace: trackingNamespace }) actionResumePageTracking;
  @Action(actionSetIsOpen, { namespace: chatNamespace }) actionSetIsChatOpen;
  @Action(actionSetFocusedRequiredId, { namespace: documentNamespace }) setFocusedRequiredId: any;
  @Action(actionSetRecipientStatus, { namespace: documentNamespace }) setRecipientStatus: any;
  @Action(actionSetAttachmentView, { namespace: documentNamespace }) setAttachmentView: any;
  @Action(actionSendDocumentStatus, { namespace: documentNamespace }) sendDocumentStatus: any;
  @Action(actionLoadAfterSign, { namespace: documentNamespace }) actionLoadAfterSign: any;
  @Action(actionRejectDocument, { namespace: documentNamespace }) actionRejectDocument: any;
  @Action(actionUploadAttachment, { namespace: documentNamespace }) actionUploadAttachment: any;
  @Action(actionLoadStripe, { namespace: integrationsNamespace }) loadStripe: any;
  @Action(actionLoadAuthorizeNet, { namespace: integrationsNamespace }) loadAuthorizeNet: any;
  @Action(actionShowInfoAlert, { namespace: alertNamespace }) actionShowInfoAlert: any;
  @Action(actionReadComments, { namespace: chatNamespace }) actionReadComments: any;
  @Action(actionSendPusherStatus, { namespace: documentNamespace }) sendPusherStatus: any;
  @Action(actionSendEventLog, { namespace: documentNamespace }) sendEventLog: any;
  @Action(actionGetPdfUrl, { namespace: documentNamespace })
  actionGetPdfUrl: () => Promise<void>;
  @Action(actionTrackVisitTime, { namespace: trackingNamespace }) actionTrackVisitTime: any;
  @Action(actionSetSystemMessageOpen, { namespace: chatNamespace }) setChatSystemMessageOpen: any;
  @Action(actionSetRecipientFirstOpen, { namespace: sessionNamespace }) setRecipientFirstOpen: any;
  @Action(actionAddVerifiedInitialFieldId, { namespace: `${documentNamespace}/${fieldNamespace}` })
  addVerifiedInitialFieldId: any;
  @Action(actionDownloadDocument, { namespace: documentNamespace }) actionDownload: any;
  @Action(actionDownloadDocumentComplete, { namespace: documentNamespace })
  actionDownloadComplete: any;

  @Getter(getterPositionedFields, { namespace: `${documentNamespace}/${fieldNamespace}` })
  fields: IField[];
  @Getter(getterPageViewStopWatchPaused, { namespace: trackingNamespace })
  pageViewStopWatchPaused: boolean;
  @Getter(getterRecipientsTurnToSign, { namespace: documentNamespace })
  recipientsTurnToSign: IRecipient;
  @Getter(getterMyTurnToSign, { namespace: documentNamespace })
  myTurnToSign: boolean;
  @Getter(getterCurrentRecipient, { namespace: documentNamespace })
  currentRecipient: IRecipient;
  @Getter('numUnreadComments', { namespace: chatNamespace })
  numUnreadComments: number;
  @Getter(getterAreAttachmentsUploading, { namespace: documentNamespace })
  areAttachmentsUploading: boolean;
  @Getter(getterVideoReminder, { namespace: documentNamespace }) getterVideoReminder: IVideo;
  @Getter(getterViewableRecipients, { namespace: documentNamespace })
  viewableRecipients: IRecipient[];

  dimensionUpdateEmitted = false;
  isEngageVideoOpen = false;
  interactionTimer: any = null;
  entityIsLoaded = false;
  showRejectModal = false;
  pageImageLoaded = false;

  showBrowserPrompt = false;
  showMainMenu = false;
  uploadAttachmentData: { show: boolean; name: string; id: string } = {
    show: false,
    name: '',
    id: '',
  };
  showSigningModal = false;
  showForwardModal = false;
  showApproveModal = false;
  showStripeModal = false;
  showAuthorizeNetModal = false;
  showRecipientsModal = false;
  showPhoneModal = false;
  showVideoReminder = false;
  isPrinting = false;
  printFrame: HTMLIFrameElement;
  showReviewChangesModal = false;
  documentPusherChannel: Channel;
  recipientPusherChannel: Channel;
  showRevisionSnackbar = false;
  waitingToShowReviewModal = false;
  forcedReviewTimer = 20;

  debouncedResetInteractionTimer: () => void = throttle(() => this.resetInteractionTimer(), 1000);

  @Watch('currentDocumentPages')
  trackPage(newPages: IDocumentPage[], oldPages: IDocumentPage[]) {
    const noActivePageTracking = !oldPages && newPages;
    if (noActivePageTracking) {
      this.actionTrackVisitTime({ pages: newPages, pageTime: 100 });
    }
    if (oldPages) {
      this.actionResetPageViewStopWatch(oldPages);
    }
    if (newPages) {
      this.actionStartPageViewStopWatch();
    }
  }

  @Watch('pageTrackingSuspended')
  suspendPageTracking(suspended: boolean) {
    if (suspended) {
      this.actionSuspendPageTracking();
    } else {
      this.actionResumePageTracking();
    }
  }

  @Watch('currentRecipient')
  handleCurrentRecipient() {
    this.toggleTracking();
  }

  @Watch('document.status')
  handleDocumentStatus() {
    this.toggleTracking();
  }

  @Watch('numUnreadComments')
  handleWatchNumUnreadComments() {
    if (this.shouldPopChat) {
      this.handleToggleChat();
    } else if (this.isChatOpen) {
      this.actionReadComments();
    }
  }

  toggleTracking(): void {
    if (
      TrackingHelper.allowedTrackingRecipientStatus(this.currentRecipient?.status) &&
      !this.isPreview &&
      this.document.status !== EDocumentStatus.Signed
    ) {
      this.actionEnableTracking();
    } else {
      this.actionDisableTracking();
    }
  }

  async loadPreviewData() {
    await this.loadDocument(this.documentId);
    this.openEngageVideoAutomatic();
    this.loadFields();
  }

  handleReject(reason: string) {
    this.handleUpdateDocumentStatus(EDocumentStatus.Rejected);
    this.actionRejectDocument({
      reason,
      recipientId: this.recipientId,
      documentId: this.document.id,
      authId: this.authId,
    });
  }

  handleUpdateDocumentStatus(status: EDocumentStatus) {
    this.sendDocumentStatus({ newDocumentStatus: status });
  }

  get showSnackbar(): boolean {
    return this.showRevisionSnackbar || this.isDownloading;
  }

  get shouldPopChat(): boolean {
    const smallScreen: boolean = isWindowSize(EWindowSize.Small);
    return (
      this.numUnreadComments > 0 &&
      !this.isChatOpen &&
      !smallScreen &&
      this.comments.length === 1 &&
      this.isAutoComment
    );
  }

  get sortedAttachments(): IDocumentAttachment[] {
    return [...this.document.documentAttachments].sort(
      (a: IDocumentAttachment, b: IDocumentAttachment) => {
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      }
    );
  }

  get pageTrackingSuspended(): boolean {
    return (
      (this.isChatOpen && isWindowSize(EWindowSize.Small)) ||
      this.showEngageVideo ||
      this.showSigningModal ||
      this.showRecipientsModal ||
      this.showRejectModal ||
      this.showUploadAttachmentModal ||
      this.showApproveModal ||
      this.showMainMenu ||
      this.showPhoneModal ||
      this.showVideoReminder
    );
  }

  get signingActions(): IDocumentOption[] {
    return documentOptions.filter((option: IDocumentOption) => {
      if (option.type === ESidebarOptionType.Call) {
        return this.activeTwilioIntegration;
      }
      if (option.type === ESidebarOptionType.Download || option.type === ESidebarOptionType.Print) {
        return this.documentExtractable;
      }
      return true;
    });
  }

  get shouldStartBankId(): boolean {
    return !!this.bankId && !!this.bankId.orderRef;
  }

  get chatEnabled(): boolean {
    return (
      this.entity &&
      !this.entity.isDisableComment &&
      this.recipient?.role !== ERecipientRole.Approver
    );
  }

  get showDocument(): boolean {
    return !!this.document;
  }

  get documentExtractable(): boolean {
    return this.entity && this.entity.documentDownload;
  }

  get allRecipients(): IRecipient[] {
    return this.viewableRecipients;
  }

  get senderAvatarUrl(): string {
    if (!this.document || !this.document.user) {
      return '';
    }
    return this.document.user.thumbUrl;
  }

  get currentRecipientsTurnToSign(): boolean {
    return this.document && this.document.nextRecipientIdToSign === this.recipientId;
  }

  get documentPages(): IDocumentPage[] {
    if (this.documentManuallySigned) {
      return [];
    }
    const mappedFields: IField[] = this.sortedFields.map((field: IField) =>
      SigningHelper.mappedFields(field, this.document, this.entity)
    );
    return PageHelper.getPagesWithFields(this.document.pages, mappedFields);
  }

  get documentManuallySigned(): boolean {
    return !!this.document?.manuallySignedPages?.length;
  }

  get manuallySignedPages(): IManuallySignedPage[] {
    if (this.documentManuallySigned) {
      return this.document.manuallySignedPages;
    }
    return [];
  }

  get recipient(): IRecipient {
    return this.allRecipients.find((recipient: IRecipient) => recipient.id === this.recipientId);
  }

  get isSignActionAllowed(): boolean {
    if (this.isPreview || !this.recipient || !this.document?.isSigning) {
      return false;
    }
    return SigningHelper.hasRecipientSigned(this.recipient.status);
  }

  get videoUrl(): string {
    return this.document.video && this.document.video.videoUrl;
  }

  get videoId(): string {
    return this.document.video && this.document.video.id;
  }

  get videoThumbnail(): string {
    return this.document.video && this.document.video.thumbUrl;
  }

  get reminderExpirationDays(): number {
    return this.entity && this.entity.reminderExpirationDays;
  }

  get requiredStepsLeft(): boolean {
    return this.requiredIds && this.requiredIds.length > 0;
  }

  get requiredIds(): string[] {
    const requiredFields: IField[] = this.fields.filter(this.isRequiredField);
    const fieldsSortedByPosition: IField[] = FieldHelper.sortByPosition(
      requiredFields,
      this.documentPages
    );
    const requiredAttachments: IDocumentAttachment[] = this.document.documentAttachments.filter(
      (attachment: IDocumentAttachment) => {
        if (attachment.attachment.attachmentType === EnumAttachmentTypes.Upload) {
          return attachment.requireView && !attachment.lastUpload;
        }
        return attachment.requireView && !attachment.lastView;
      }
    );
    return [
      ...fieldsSortedByPosition.map((field: IField) => field.id),
      ...requiredAttachments.map((attachment: IDocumentAttachment) => attachment.id),
    ];
  }

  isRequiredField(field: IField): boolean {
    if (field.recipientId !== this.recipientId) {
      return false;
    }
    const isEmptyInitialsField: boolean =
      field.type === EFieldType.Initials && !this.verifiedInitialFieldIds.includes(field.id);

    const isEmptyRequiredField: boolean = !field.value && field.isRequired;

    return isEmptyRequiredField || isEmptyInitialsField || this.isInvalidFieldValue(field);
  }

  get nextRequiredId(): string {
    return (
      (this.requiredIds &&
        this.requiredIds[this.requiredIds.indexOf(this.focusedRequiredId) + 1]) ||
      this.requiredIds[0] ||
      null
    );
  }

  isInvalidFieldValue(field: IField): boolean {
    if (field.type !== EFieldType.Formatted) {
      return false;
    }
    return !!field.value && !new RegExp(field.validationRegex).test(field.value);
  }

  get sortedFields(): IField[] {
    return FieldHelper.sortByPosition(this.fields, this.document.pages) || [];
  }

  get activeTwilioIntegration(): boolean {
    return this.document && this.document.activeTwilioIntegration;
  }

  get documentLogo(): string {
    return BrandingHelper.getLogoUrl(this.theme);
  }

  get showEngageVideo(): boolean {
    if (!this.document || !this.document.isVideo) {
      return false;
    }
    return this.isEngageVideoOpen;
  }

  get showUploadAttachmentModal(): boolean {
    return this.uploadAttachmentData && this.uploadAttachmentData.show;
  }

  get isBottomBarVisible(): boolean {
    return this.isSignActionAllowed && this.document.status !== EDocumentStatus.Signed;
  }

  get isSigningEnabled(): boolean {
    return this.myTurnToSign;
  }

  get emptyBottomBar(): boolean {
    return this.isPreview || this.recipient.role === ERecipientRole.CC;
  }

  get showReject(): boolean {
    return (
      !this.isPreview && this.isSigningEnabled && this.pageImageLoaded && !this.hasRecipientSigned
    );
  }

  get hasRecipientSigned(): boolean {
    return this.recipient.role === ERecipientRole.Signer
      ? this.recipient.status === ERecipientStatus.Signed
      : this.recipient.status === ERecipientStatus.Approved;
  }

  get latestSealedRevision(): IDocumentRevision {
    const sealedRevisions = this.document?.documentRevisions?.filter(
      revision => revision.status === EDocumentRevisionStatus.Sealed
    );
    if (!sealedRevisions || !sealedRevisions.length) {
      return null;
    }
    return sealedRevisions[sealedRevisions.length - 1];
  }

  get documentName(): string {
    return this.document?.name;
  }

  get senderFullName(): string {
    return this.document?.user?.fullName;
  }

  get reviewLoading(): boolean {
    return this.revisionsIsLoading || this.revisionsViewedLoading;
  }

  get reviewPending(): boolean {
    return (
      (this.document?.documentRevisions?.length > 1 &&
        !this.latestSealedRevision.viewedByRecipient) ||
      this.waitingToShowReviewModal
    );
  }

  toggleShowVideoReminder(show: boolean) {
    this.showVideoReminder = show;
  }

  openEngageVideoAutomatic() {
    if (
      this.recipientFirstOpen &&
      this.document &&
      this.document.status !== EDocumentStatus.Rejected &&
      this.document.status !== EDocumentStatus.Lost &&
      this.document.isVideo
    ) {
      this.isEngageVideoOpen = true;
    }
  }

  handleImageLoaded() {
    this.pageImageLoaded = true;
    this.setScrollToBottomListener();
  }

  setScrollToBottomListener() {
    if (
      this.isPreview ||
      this.recipient.status === ERecipientStatus.Reviewed ||
      this.recipient.status === ERecipientStatus.Signed ||
      this.recipient.status === ERecipientStatus.Approved
    ) {
      return;
    }
    this.checkScrolledToBottom();
    window.addEventListener('scroll', this.checkScrolledToBottom, { passive: true });
  }

  handleToggleChat() {
    if (this.chatSystemMessageOpen) {
      this.setChatSystemMessageOpen(false);
    }
    this.actionSetIsChatOpen(!this.isChatOpen);
  }

  handleUpdateRecipientStatus(status: ERecipientStatus) {
    this.setRecipientStatus({ status });
  }

  handleUpdateFocusedRequiredId(focusedRequiredId: string) {
    if (this.focusedRequiredId === focusedRequiredId) {
      this.setFocusedRequiredId(null);
      this.$nextTick(() => {
        this.setFocusedRequiredId(focusedRequiredId);
      });
    } else {
      this.setFocusedRequiredId(focusedRequiredId);
    }
  }

  handleClickLinkField(id: string) {
    this.actionTrackFieldClick(id);
  }

  handleClickSignField() {
    if (
      this.recipient.status === ERecipientStatus.Reviewed &&
      this.recipient.role === ERecipientRole.Signer
    ) {
      this.handleToggleSigningModal(true);
    }
  }

  handleContentLinkClick(id: string) {
    this.actionTrackContentLinkClick(id);
  }

  handleVideoIntro() {
    this.isEngageVideoOpen = true;
  }

  handleCurrentPages(pageIds: string[]) {
    const currentPages: IDocumentPage[] = this.document.pages.filter((page: IDocumentPage) => {
      return pageIds.find(pageId => pageId === page.id);
    });
    this.actionSetCurrentDocumentPages(currentPages);
  }

  handleToggleMenu() {
    this.showMainMenu = !this.showMainMenu;
    document.body.style.overflow = this.showMainMenu ? 'hidden' : '';
  }

  handleUpdateField({ fieldId, value }: { fieldId: string; value: string }) {
    this.actionUpdateFieldValue({ fieldId, value });
  }

  handleUpdatePageWidth(offsetWidth: number) {
    this.updatePageWidth(offsetWidth);
  }

  handleAttachmentUpload(file: File) {
    const uploadAttachment: IUploadAttachment = {
      documentId: this.document.id,
      recipientId: this.recipientId,
      attachmentId: this.uploadAttachmentData.id,
      authId: this.authId,
      file,
    };
    this.actionUploadAttachment({ uploadAttachment, document: this.document });
  }

  handleToggleUploadAttachmentModal(
    payload: { attachmentId: string; name: string },
    show: boolean
  ) {
    if (show) {
      this.uploadAttachmentData = {
        id: payload.attachmentId,
        name: payload.name,
        show,
      };
    } else {
      this.uploadAttachmentData = {
        id: '',
        name: '',
        show,
      };
    }
  }

  sendPageTrackingHeartBeat(): void {
    if (
      this.currentDocumentPages?.length &&
      !this.pageViewStopWatchPaused &&
      !this.isEngageVideoOpen
    ) {
      this.actionResetPageViewStopWatch(this.currentDocumentPages);
      this.actionStartPageViewStopWatch();
    }
  }

  startPageTrackingHeartBeat(): void {
    setInterval(this.sendPageTrackingHeartBeat, pageTrackingHeartbeatInterval);
  }

  resetInteractionTimer(): void {
    if (this.interactionTimer) {
      clearTimeout(this.interactionTimer);
      this.interactionTimer = null;
    }
    this.actionResumePageViewStopWatch();
    this.interactionTimer = setTimeout(() => {
      this.actionPausePageViewStopWatch();
    }, idleInteractionInterval);
  }

  handleCloseSystemMessage() {
    this.setChatSystemMessageOpen(false);
  }

  get isAutoComment(): boolean {
    if (this.document.isAutoComment === -1) {
      return !!this.entity.isAutoComment;
    }

    return !!this.document.isAutoComment;
  }

  get isSigningForward(): boolean {
    return !!this.document.isSigningForward;
  }

  automaticChatMessage() {
    if (!this.recipientFirstOpen) {
      return;
    }
    setTimeout(() => {
      if (this.isAutoComment) {
        this.autoComment();
      } else {
        this.setChatSystemMessageOpen(true);
      }
      this.setRecipientFirstOpen(false);
    }, 10000);
  }

  async loadData() {
    await this.loadDocument(this.documentId);
    await this.loadStripe();
    await this.loadAuthorizeNet();
    if (this.getterVideoReminder) {
      this.toggleShowVideoReminder(true);
    } else {
      this.openEngageVideoAutomatic();
    }
    await this.loadFields();
    await this.loadChat();
    if (!this.document.isVideo) {
      this.automaticChatMessage();
    }
  }

  async addSubscriptions(documentId: string) {
    this.$apollo.addSmartSubscription('signedThumbDone', {
      query: documentSignaturePagesSubscription,
      variables: { documentId },
      result(data) {
        if (data) {
          this.actionLoadAfterSign();
        }
      },
    });

    this.$apollo.addSmartSubscription('chatUpdatedSubsciption', {
      query: chatUpdatedSubscription,
      variables: { documentId: this.documentId },
      result() {
        this.loadChat();
      },
    });
  }

  async addPusherSubscriptions() {
    this.documentPusherChannel = await this.$pusher.subscribe(
      this.token.jwt,
      ChannelType.Document,
      this.documentId
    );
    this.recipientPusherChannel = await this.$pusher.subscribe(
      this.token.jwt,
      ChannelType.Recipient,
      this.recipientId
    );
    this.$pusher.listen(
      this.documentPusherChannel,
      PusherEvent.Sealed,
      (sealed: { documentId: string; entityId: string; revision: number }) => {
        if (sealed) {
          this.handleNewRevisionPushed(reviewTimerDuration);
        }
      }
    );
    this.$pusher.listen(
      this.recipientPusherChannel,
      PusherEvent.DownloadDocumentResponse,
      ({ url }: { url: string }) => {
        if (this.isPrinting) {
          this.prepareForPrint(url);
        } else if (this.isDownloading) {
          this.handleDownloadComplete(url);
        }
        this.actionDownloadComplete();
      }
    );
  }

  handleDownloadComplete(url: string): void {
    this.sendPusherStatus({ status: EDocumentEvent.Downloaded });
    this.sendEventLog({ event: EDocumentEvent.Downloaded });
    const newWindow: Window = window.open(url, '_blank');
    if (isPopupBlocked(newWindow)) {
      this.handleDownloadCompleteFallback(url);
    }
  }

  handleDownloadCompleteFallback(url: string): void {
    const link = document.createElement('a');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  handleNewRevisionPushed(timerDuration: number) {
    this.showRevisionSnackbar = true;
    this.startForcedReviewTimer(timerDuration);
    this.waitingToShowReviewModal = true;
    setTimeout(() => {
      if (this.waitingToShowReviewModal) {
        this.hideModals();
        this.loadDocumentRevisions();
        this.waitingToShowReviewModal = false;
        this.showReviewChangesModal = true;
      }
    }, timerDuration);
  }

  handleShowReviewChangesModal() {
    this.waitingToShowReviewModal = false;
    this.loadDocumentRevisions();
    this.showRevisionSnackbar = false;
    this.showReviewChangesModal = true;
  }

  async handleReviewChanges() {
    this.forcedReviewTimer = 20;
    this.loadDocumentRevisions();
    if (!this.latestSealedRevision.viewedByRecipient) {
      await this.setRevisionViewed(this.latestSealedRevision.revision);
      this.loadData();
    }
    this.showReviewChangesModal = false;
  }

  startForcedReviewTimer(duration: number) {
    let timeleft = duration / 1000;
    const timer = setInterval(() => {
      if (timeleft === 0 || !this.waitingToShowReviewModal) {
        clearInterval(timer);
      } else {
        timeleft -= 1;
      }
      this.setForcedReviewTimer(timeleft);
    }, 1000);
  }

  setForcedReviewTimer(timeleft: number) {
    this.forcedReviewTimer = timeleft;
  }

  hideModals() {
    this.showSigningModal = false;
    this.showForwardModal = false;
    this.showApproveModal = false;
    this.showStripeModal = false;
    this.showAuthorizeNetModal = false;
    this.showRecipientsModal = false;
    this.showRevisionSnackbar = false;
  }

  created() {
    this.hideModals();
  }

  async mounted() {
    window.addEventListener('blur', this.actionPausePageViewStopWatch, true);
    window.addEventListener('focus', this.actionResumePageViewStopWatch, true);
    window.addEventListener('mousemove', this.debouncedResetInteractionTimer, true);
    window.addEventListener('scroll', this.debouncedResetInteractionTimer, true);
    window.addEventListener('afterprint', this.printPrompt);

    if (this.isPreview) {
      await this.loadPreviewData();
    } else {
      await this.loadData();
      this.resetInteractionTimer();
      this.startPageTrackingHeartBeat();
      this.addSubscriptions(this.documentId);
    }
    this.checkBrowserSupport();
  }

  beforeDestroy() {
    window.removeEventListener('blur', this.actionPausePageViewStopWatch, true);
    window.removeEventListener('focus', this.actionResumePageViewStopWatch, true);
    window.removeEventListener('mousemove', this.debouncedResetInteractionTimer, true);
    window.removeEventListener('scroll', this.debouncedResetInteractionTimer, true);
    window.removeEventListener('afterprint', this.printPrompt);
    window.removeEventListener('scroll', this.checkScrolledToBottom);
  }

  async handleSelect(type: ESidebarOptionType) {
    switch (type) {
      case ESidebarOptionType.Recipient: {
        this.handleOpenRecipients();
        break;
      }
      case ESidebarOptionType.Chat: {
        this.handleToggleChat();
        break;
      }
      case ESidebarOptionType.Invite: {
        this.handleToggleForwardModal(true);
        break;
      }
      case ESidebarOptionType.Download: {
        this.downloadDocument();
        break;
      }
      case ESidebarOptionType.Print: {
        this.isPrinting = true;
        this.actionDownload();
        break;
      }
      case ESidebarOptionType.Call: {
        this.handleOpenPhoneModal();
        break;
      }
      case ESidebarOptionType.Reject: {
        this.toggleReject(true);
        break;
      }
      case ESidebarOptionType.Help: {
        window.open(
          'http://help.getaccept.com/en/articles/4175027-issues-related-to-document',
          '_blank'
        );
        break;
      }
      default: {
        break;
      }
    }
  }

  async downloadDocument() {
    if (this.document.status === EDocumentStatus.Signed) {
      await this.actionGetPdfUrl();
      this.handleDownloadComplete(this.pdfUrl);
    } else if (!this.isDownloading) {
      this.actionDownload();
    }
  }

  prepareForPrint(printUrl: string) {
    const req = new XMLHttpRequest();
    req.open('GET', printUrl, true);
    req.responseType = 'blob';
    req.onload = this.printDocument;
    req.send();
  }

  printDocument({ target }: ProgressEvent) {
    const blob = (target as XMLHttpRequest).response;
    const dataUrl = window.URL.createObjectURL(blob);

    try {
      printJS(dataUrl);
      this.sendPusherStatus({ status: EDocumentEvent.Printed });
      this.sendEventLog({ event: EDocumentEvent.Printed });
    } catch (e) {
      this.actionShowInfoAlert(this.$t('printer-not-found'));
    }
    this.isPrinting = false;
  }

  printPrompt() {
    this.actionShowInfoAlert(this.$t('please-use-print-button'));
  }

  sendMessage(text: string): void {
    this.addComment(text);
  }

  checkBrowserSupport() {
    this.showBrowserPrompt = !supportedBrowsersRegExp.test(navigator.userAgent);
  }

  hideBrowserPrompt() {
    this.showBrowserPrompt = false;
  }

  handleOpenRecipients() {
    this.showRecipientsModal = true;
  }

  handleOpenPhoneModal() {
    this.showPhoneModal = true;
  }

  handleClosePhoneModal() {
    this.showPhoneModal = false;
  }

  handleCloseRecipientsModal() {
    this.showRecipientsModal = false;
  }

  handleCloseEngageVideo() {
    this.automaticChatMessage();
    this.isEngageVideoOpen = false;
  }

  handleToggleStripe(visible: boolean) {
    if (this.stripeIntegration && !!this.document.value) {
      this.showSigningModal = false;
      this.showStripeModal = visible;
    }
  }

  handleToggleAuthorizeNet(visible: boolean) {
    if (this.authorizeNetIntegration && !!this.document.value) {
      this.showSigningModal = false;
      this.showAuthorizeNetModal = visible;
    }
  }

  handleTrackVideo(payload: { id: string; viewDuration: number }) {
    this.actionTrackVideo(payload);
  }

  handleAttachmentView(id: string) {
    this.setAttachmentView(id);
  }

  toggleReject(open: boolean) {
    this.showRejectModal = open;
  }

  handleToggleSigningModal(open: boolean) {
    if (this.waitingToShowReviewModal) {
      this.handleShowReviewChangesModal();
      return;
    }
    this.showSigningModal = open;
  }

  handleToggleApproveModal(open: boolean) {
    this.showApproveModal = open;
  }

  handleToggleForwardModal(open: boolean) {
    this.showForwardModal = open;
    if (!open) {
      this.actionSetForwardStatus(false);
    }
  }

  handleApproveDocument() {
    this.actionApproveDocument();
  }

  handleForwardDocument(recipientInfo: IForwardRecipientInfo) {
    this.actionForwardToRecipient(recipientInfo);
  }

  checkScrolledToBottom() {
    if (
      this.isPreview ||
      this.recipient.status === ERecipientStatus.Reviewed ||
      this.recipient.status === ERecipientStatus.Signed ||
      this.recipient.status === ERecipientStatus.Approved
    ) {
      return;
    }
    if (this.hasScrolledToBottom()) {
      this.handleUpdateRecipientStatus(ERecipientStatus.Reviewed);
      window.removeEventListener('scroll', this.checkScrolledToBottom);
    }
  }

  hasScrolledToBottom(): boolean {
    const scrollPosition: number = Math.ceil(window.pageYOffset);
    const windowHeight: number = window.innerHeight;
    const documentHeight: number = document.getElementById('document-wrapper').offsetHeight;
    return (
      SigningHelper.isFullDocumentHeightVisible(windowHeight, documentHeight) ||
      SigningHelper.hasScrolledToBottom(scrollPosition, windowHeight, documentHeight)
    );
  }

  handleIntialsSubmit(initials: string) {
    this.addInitials({ initials, fieldId: this.selectedInitialFieldId });
  }

  handleIntialsCancel() {
    this.setSelectedInitialFieldId('');
  }

  handleClickInitialsField(fieldId: string) {
    if (!this.initials || this.isFieldVerified(fieldId)) {
      this.setSelectedInitialFieldId(fieldId);
      return;
    }
    this.addVerifiedInitialFieldId(fieldId);
  }

  isFieldVerified(fieldId: string): boolean {
    return this.verifiedInitialFieldIds.includes(fieldId);
  }
}
